import * as React from 'react';
import { Layout } from '../components/layout';
import { Certificados } from '../pages/certificados/certificados';
import AberturaChamado from '../pages/abertura-chamado/abertura-chamado';

const headerProps = {
  name: 'Certificados',
};

export const ClientRoutes = [
  {
    routePath: '/certificados',
    isExactPath: true,
    pageToRender: (
      <Layout headerProps={headerProps}>
        <Certificados />
      </Layout>
    ),
  },
  {
    routePath: '/abertura-chamado',
    isExactPath: true,
    pageToRender: (
      <Layout>
        <AberturaChamado />
      </Layout>
    ),
  },
];
